export function getTranslatedMsg(id,data,loc,groupId,defaultMsg){
    if(data!==undefined && data!==null ){
        if(Object.keys(data["RCI"][loc]).length!==0){
            
            if(data["RCI"][loc][groupId][id]!==undefined ){
                return data["RCI"][loc][groupId][id]['translatedMessage']
            }else{
                return  defaultMsg;
            }

        }else{
            return  defaultMsg;
        }
       
    }else{
        return  defaultMsg;
    }
}